module.exports = __webpack_public_path__ + "static/img/pattern-right.0b948751.png";